import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcSoftware = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M5.875 7a.875.875 0 1 0 0 1.75h4.25a.875.875 0 0 0 0-1.75h-4.25Zm0 3a.875.875 0 0 0 0 1.75h2.25a.875.875 0 0 0 0-1.75h-2.25Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2.5 3A1.5 1.5 0 0 0 1 4.5v10A1.5 1.5 0 0 0 2.5 16h5v2h-1a.5.5 0 0 0 0 1h5v-4.75H2.75v-9.5h13.5v6.217l1.75-.934V4.5A1.5 1.5 0 0 0 16.5 3h-14Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M18.385 12.66a1 1 0 0 0-.77 0l-3.45 1.438a.3.3 0 0 0 0 .554l3.45 1.437a1 1 0 0 0 .77 0l3.45-1.437a.3.3 0 0 0 0-.554l-3.45-1.438Zm-1.135 5.517a1 1 0 0 0-.629-.929l-2.778-1.111a.25.25 0 0 0-.343.232v3.454a1 1 0 0 0 .629.928l2.778 1.111a.25.25 0 0 0 .343-.232v-3.453Zm4.907-2.04a.25.25 0 0 1 .343.232v3.454a1 1 0 0 1-.629.928l-2.778 1.111a.25.25 0 0 1-.343-.232v-3.453a1 1 0 0 1 .629-.929l2.778-1.111Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcSoftware");

export { IcSoftware };
//# sourceMappingURL=ic-software.js.map
